// import Joi from "joi-browser";
import auth from "../../services/authService";
import Input from "../common/useform/input";
import { toast } from "react-toastify";
import { Redirect } from "react-router-dom";
import { useHistory } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
// import { Grid, TextField } from "@material-ui/core";
import { useForm } from "react-hook-form";
// import { joiResolver } from "@hookform/resolvers/joi";
// import Joi from "joi";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { PermissionContext } from "../../context/permissionContext";
import { loadMenulByToken } from "../../services/authService";
const toastOptions = { position: toast.POSITION.BOTTOM_RIGHT };

const LoginForm = () => {
  const history = useHistory();
  const { setPermission } = useContext(PermissionContext);

  const getMenu = async (token) => {
    const result = await loadMenulByToken(token);

    if (result) {
      //console.log(result)
      if (result.status === "success") {
        setPermission(result.data.menuItems);

        const { state } = this.props.location;
        window.location = state ? state.from.pathname : "/"; //Full refresh
      } else if (result.status === "error") {
      }
    }
  };

  const handelReister = () => {
    // setisRegis(!isRegis);
    history.push("/RegisterAccount");
  };

  const schema = yup.object({
    username: yup
      .string()
      .required("กรุณาระบุ account ผู้ใช้งาน")
      .label("Username"),
    password: yup.string().required("กรุณาระบุรหัสผ่าน").label("Password"),
    // acceptTerms: yup.bool().oneOf([true], "Accept Ts & Cs is required"),
    // Age: yup.number().positive().integer().required().min(1, "Min value 0."),
  });
  // const schema = Joi.object({
  //   username: Joi.string().required().label("Username"),
  //   password: Joi.string().required().label("Password"),
  // });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const doSubmit = async () => {
    handleSubmit(
      async (data, e) => {
        try {
          const result = await auth.login(data.username, data.password);

          if (result.result === "OK") {
            await getMenu(result.token);

            // const { state } = this.props.location;
            // window.location = state ? state.from.pathname : "/"; //Full refresh
          } else {
            toast.error(result);
          }
        } catch (err) {
          if (err.response && err.response.status === 400) {
            toast.error(err.response.data);
          }
        }
      },

      (error) => {
        toast.error("Username and Password are required", toastOptions);
      }
    )();
  };

  if (auth.getCurrentUser()) return <Redirect to="/" />;

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div className="vh-100">
        <div className="authincation h-50">
          <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-center ">
              <div className="col-xl-4 col-md-6 shadow-lg mt-3">
                <div className="authincation-content">
                  <div className="row no-gutters">
                    <div className="col-xl-12">
                      <div className="auth-form">
                        <div className="text-center mb-3">
                          <i
                            className="fas fa-user-circle"
                            style={{ fontSize: "48px" }}
                          />
                        </div>
                        <h4 className="text-center mb-4">
                          Sign in your account
                        </h4>
                        <div className="m-2">
                          <Input
                            label="account"
                            name="username"
                            register={register}
                            required
                            errors={errors.username}
                          />
                        </div>
                        <div className="m-2">
                        <Input
                          type="password"
                          label="password"
                          name="password"
                          register={register}
                          required
                          errors={errors.password}
                        />
                           </div>
                        <div className="form-row d-flex justify-content-between mt-4 mb-2">
                          <div className="form-group">
                            {/* <div className="custom-control custom-checkbox ml-1">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="basic_checkbox_1"
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="basic_checkbox_1"
                              >
                                Remember my preference
                              </label>
                            </div> */}
                          </div>
                          <div className="form-group">
                            {/* <a href="page-forgot-password.html">Forgot Password?</a> */}
                          </div>
                        </div>
                        <div className="row d-flex justify-content-center">
                          <div className=" col-auto">
                            <button
                              type="submit"
                              onClick={handleSubmit(doSubmit)}
                              className="btn btn-primary btn-block"
                            >
                              Sign In
                            </button>
                          </div>
                          <div className=" col-auto">
                            <button
                              type="submit"
                              onClick={() => handelReister()}
                              className="btn btn-success btn-block"
                            >
                              Register
                            </button>
                          </div>
                        </div>

                        {/* <div className="new-account mt-3">
                          <p>
                            Don't have an account?{" "}
                            <a
                              className="text-primary"
                              href="page-register.html"
                            >
                              Sign up
                            </a>
                          </p>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <main
        role="main"
        className="container-fluid"
        style={{ padding: "33px", marginTop: "30px" }}
      >
        <div className="authincation h-100">
          <div className="container h-100">
            <div className="mt-5 row justify-content-center h-100 align-items-center">
              <div className="col-md-6">
                <div className="authincation-content">
                  <div className="row no-gutters">
                    <div className="col-xl-12">
                      <div className="auth-form">
                        <div className="text-center mb-3">
                          <i
                            className="fas fa-user-circle"
                            style={{ fontSize: "48px" }}
                          />
                       
                        </div>
                        <h4 className="text-center mb-4">
                          Sign in your account
                        </h4>
                      
                        <div className="row justify-content-center">
                          <div>
                          

                            <div className="mt-4">
                              <div className="mb-3">
                                <Input
                                  label="User Name"
                                  name="username"
                                  register={register}
                                  placeholder="ระบุผู้ใช้งาน"
                                  required
                                  errors={errors.username}
                                />
                              </div>
                              <div className="mb-3">
                                <Input
                                type ="password"
                                  label="Pass Word"
                                  name="password"
                                  register={register}
                                  placeholder="ระบุรหัสผ่าน"
                                  required
                                  errors={errors.password}
                                />
                              </div>
                   
                            </div>
                            <div>
                              <div className="row d-flex justify-content-between mt-4 mb-2">
                                <div className="mb-3">
                                  <div className="form-check custom-checkbox ms-1">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="basic_checkbox_1"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="basic_checkbox_1"
                                    >
                                      Remember my preference
                                    </label>
                                  </div>
                                </div>
                            
                              </div>
                              <div className="text-center">
                                <button
                                  type="submit"
                                  onClick={handleSubmit(doSubmit)}
                                  className="btn btn-primary btn-block"
                                >
                                  Sign Me In
                                </button>
                              </div>
                             
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main> */}
      </div>
    </form>
  );
};

export default LoginForm;
